export default "<button aria-hidden=\"true\">\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n</button>\r\n"